import { ExternalVideoType } from "../../types"

export const VideoLinks: {
  [key in ExternalVideoType]: { title: string; link: string }
} = {
  engagements: {
    title: "Engagements - Learn how this works",
    link: "//fast.wistia.net/embed/iframe/d8hu7tzu6k"
  },
  leads: {
    title: "Website Leads - Learn how this works",
    link: "//fast.wistia.net/embed/iframe/x124y4m3za"
  },
  conversations: {
    title: "Conversations - Learn how this works",
    link: "//fast.wistia.net/embed/iframe/yu27q9mrg4"
  },
  "dream-rate": {
    title: "Dream rate - Learn how this works",
    link: "//fast.wistia.net/embed/iframe/j4ewncmbm6"
  }
}
